import { MODAL_TYPES } from 'Constants/modal';
import { downloadFile } from 'Helpers/utils';
import { useDispatch } from 'react-redux';
import { addModal } from 'Redux/modules/modal/actions';

const usePreviewFile = () => {
  const dispatch = useDispatch();

  const handlePreview = (file, token) => {
    const isImage = file.mime.includes('image');
    const isPdf = file.mime.includes('pdf');
    // Add your code here
    switch (true) {
      case isImage:
        dispatch(
          addModal({
            type: MODAL_TYPES.PREVIEW_IMG,
            id: MODAL_TYPES.PREVIEW_IMG,
            data: {
              content: file.originalPath,
              closeOnDimmerClick: true,
            },
          }),
        );
        break;
      case isPdf:
        window.open(file?.originalPath, '_blank');
        break;
      default: {
        downloadFile(file?.originalPath, token, file?.name);
        break;
      }
    }
  };

  return { handlePreview };
};

export default usePreviewFile;
